export default __webpack_public_path__ + "static/beach-vid-b0020edb6eb1dfb49b271488f32816e5.mp4";